module.exports = __webpack_public_path__ + "static/media/NewUsers.ec0108df.svg";